export default {
    'duration-of-visit-in-minutes': 'مدة الزيارة بالدقائق',
    'distributed-samples': 'العينات الموزعة',
    'unavailable-products': 'العينات الغير متوفرة'
}